import React from 'react';
import { Navigate } from 'react-router';

import { SettingsUserContainer } from './SettingsUserContainer';
import { Typography } from 'packages/common-frontend/components/Typography';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

// Exports
export const Route = () => {
  // Visibility rules: any logged-in user
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <Typography variant="page-title">User Information</Typography>
      <SettingsUserContainer />
    </RouteErrorBoundary>
  );
};
